import React from 'react';
import TransactionInformation from 'modules/common/components/TransactionInformation';
import _ from 'lodash';
import PropTypes from 'prop-types';

const CedulaIndividualContent = ({ taxpayer, transactionInfo }) => {
  const getInitials = (cString) => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  const isEmployed = _.get(taxpayer, 'is_employed_individual');

  return (
    <>
      <div className="card-section-content container-fluid citizen-tabs">
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-center">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {_.get(
                          transactionInfo,
                          'included.taxPayer.attributes.photo'
                        ) !== '-/format/jpeg/' ? (
                          <img
                            alt="Client Profile"
                            src={_.get(
                              transactionInfo,
                              'included.taxPayer.attributes.photo'
                            )}
                          />
                        ) : (
                          getInitials(
                            `${_.get(taxpayer, 'first_name')} ${_.get(
                              taxpayer,
                              'middle_name'
                            )} ${_.get(taxpayer, 'last_name')}`
                          )
                        )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(taxpayer, 'first_name') || '-'} ${
                          _.get(taxpayer, 'middle_name') || ''
                        } ${_.get(taxpayer, 'last_name') || ''} ${
                          _.get(taxpayer, 'extension_name') || ''
                        }`}
                      </h1>
                    </div>
                    <div className="d-flex ml-auto">&nbsp;</div>
                  </div>
                  <TransactionInformation
                    module="citizen"
                    transactionInfo={transactionInfo}
                    taxpayer={taxpayer}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-1 pb-1 px-3">
            <div className="col-12">
              <table className="transaction-table table table-borderless table-sm table-striped table-hover">
                <tbody>
                  <tr>
                    <td className="text-dark" width="250">
                      First Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(_.get(taxpayer, 'first_name') || '--').toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Middle Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(_.get(taxpayer, 'middle_name') || '--').toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Last Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(_.get(taxpayer, 'last_name') || '--').toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Extension Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'extension_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Tax Payer Account No:
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'tax_payer_account_number') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Address
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{_.get(taxpayer, 'address') || '--'}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Is Employed
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{isEmployed ? 'YES' : 'NO'}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Sex
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{(_.get(taxpayer, 'gender') || '--').toUpperCase()}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Civil Status
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'civil_status') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Citizenship
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(_.get(taxpayer, 'citizenship') || '--').toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      ACR No. (if alien)
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(_.get(taxpayer, 'acr_number') || '--').toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Place of Birth
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'place_of_birth') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Date of Birth
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{_.get(taxpayer, 'birth_date') || '--'}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Profession/Occupation Business
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(_.get(taxpayer, 'profession') || '--').toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Height
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{(_.get(taxpayer, 'height') || '--').toUpperCase()}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Weight
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{(_.get(taxpayer, 'weight') || '--').toUpperCase()}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Residence Tax Due
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{_.get(taxpayer, 'residence_tax_due') || '--'}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

CedulaIndividualContent.defaultProps = {
  taxpayer: {},
  transactionInfo: {},
};

CedulaIndividualContent.propTypes = {
  taxpayer: PropTypes.instanceOf(Object),
  transactionInfo: PropTypes.instanceOf(Object),
};

export default CedulaIndividualContent;
